var _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew227({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.92,
    y: 3.71,
    width: 14.16,
    height: 8.58
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.62,6H3.8v.43H2.14V7.76H3.67v.43H2.14V10H1.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.73,8.75,4.31,10H3.77L5.14,6h.63l1.38,4H6.6L6.16,8.75Zm1.33-.41-.4-1.17c-.09-.26-.15-.5-.21-.73h0c-.06.24-.13.48-.21.73L4.84,8.34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.75,6A7.22,7.22,0,0,1,8.86,6a2.33,2.33,0,0,1,1.64.5,1.86,1.86,0,0,1,.56,1.45,2.12,2.12,0,0,1-.58,1.57,2.46,2.46,0,0,1-1.78.58,8.54,8.54,0,0,1-.95,0ZM8.27,9.6a2.7,2.7,0,0,0,.53,0,1.55,1.55,0,0,0,1.72-1.71A1.44,1.44,0,0,0,8.88,6.36a3,3,0,0,0-.61,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.75,6a5.78,5.78,0,0,1,1-.08,1.67,1.67,0,0,1,1.17.33,1,1,0,0,1,.31.76,1,1,0,0,1-.76,1v0a1,1,0,0,1,.6.82A6,6,0,0,0,14.38,10h-.54a4.71,4.71,0,0,1-.27-1c-.12-.56-.34-.77-.81-.78h-.49V10h-.52Zm.52,1.84h.53c.56,0,.91-.31.91-.77s-.38-.75-.93-.75a1.78,1.78,0,0,0-.51.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew227);
export default __webpack_public_path__ + "static/media/Symbolpack_New_227.a2dd37f98384953ef46c81a85cd97ad7.svg";
export { ForwardRef as ReactComponent };